import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import MCSSideNavPanel from "components/MCSSideNavPanel";
import { useAuthContextUser } from "context/AuthContext";
import { AdminRoutes } from "_constants/PageRoutes";

function AdminNavPanel(props) {
  const location = useLocation();
  const user = useAuthContextUser();
  const userManagementRoutes = [AdminRoutes.ACCESSREQUEST, AdminRoutes.MANAGEORGANIZATIONS, AdminRoutes.MANAGEUSERS];
  const libraryManagementRoutes = [AdminRoutes.MANAGELIBRARY, AdminRoutes.MANAGELIBRARY_TAG, AdminRoutes.MANAGELIBRARY_POSTACCESSHISTORY];
  const billingManagementRoutes = [AdminRoutes.MANAGEBILLINGLINES, AdminRoutes.MANAGEBILLINGLINES_REVIEW];
  const subscriptionManagementRoutes = [AdminRoutes.MANAGESUBSCRIPTION_ORDER, AdminRoutes.MANAGESUBSCRIPTION];

  const [tabSelected, setTabSelected] = useState(0);
  const isPath = (el) => location.pathname === el;
  const [userManagementGroup, setUserManagementGroup] = useState(userManagementRoutes.findIndex(isPath) !== -1);
  const [libraryManagementGroup, setLibraryManagementGroup] = useState(libraryManagementRoutes.findIndex(isPath) !== -1);
  const [billingManagementGroup, setBillingManagementGroup] = useState(billingManagementRoutes.findIndex(isPath) !== -1);
  const [subscriptionManagementGroup, setSubscriptionManagementGroup] = useState(subscriptionManagementRoutes.findIndex(isPath) !== -1);

  const adminMenuList = [
    {
      type: "item",
      iconName: "notifications",
      label: "Announcement Management",
      route: AdminRoutes.ANNOUNCEMENT,
    },
    {
      type: "menu",        
      iconName: "folder-account",
      label: "User Management",
      parentState: userManagementGroup,
      openParent: setUserManagementGroup,
    },
    {
      type: "child",
      visible: user && (user.isSuperAdmin || user.isToolsAndLibAdmin),
      iconName: "money-request",
      label: "Access Requests",
      parentState: userManagementGroup,
      route: AdminRoutes.ACCESSREQUEST,
      openParent: setUserManagementGroup,
    },
    {
      type: "child",
      iconName: "company",
      label: "Organizations",
      parentState: userManagementGroup,
      route: AdminRoutes.MANAGEORGANIZATIONS,
      openParent: setUserManagementGroup,
    },
    {
      type: "child",        
      iconName: "account",
      label: "Users",
      parentState: userManagementGroup,
      route: AdminRoutes.MANAGEUSERS,
      openParent: setUserManagementGroup,
    },
    {
      type: "menu",
      visible: user && (user.isSuperAdmin || user.isToolsAndLibAdmin),
      iconName: "view-list",
      label: "Billing Lines Management",
      parentState: billingManagementGroup,
      openParent: setBillingManagementGroup,
    },
    {
      type: "child",        
      visible: user && (user.isSuperAdmin || user.isToolsAndLibAdmin),
      iconName: "bill-alt",
      label: "Manage Billing Lines",
      parentState: billingManagementGroup,
      route: AdminRoutes.MANAGEBILLINGLINES,
      openParent: setBillingManagementGroup,
    },
    {
      type: "child",
      visible: user && (user.isSuperAdmin || user.isSifManager),
      iconName: "log-completed",
      label: "Billing Sign Off",
      parentState: billingManagementGroup,
      route: AdminRoutes.MANAGEBILLINGLINES_REVIEW,
      openParent: setBillingManagementGroup,
    },
    {
      type: "item",
      visible: user && user.isSuperAdmin,
      iconName: "currency",
      label: "Fee Waivers Management",
      route: AdminRoutes.MANAGEFEEWAIVERS,
    },
    {
      type: "menu",
      visible: user && user.isAdmin,
      iconName: "offers",
      label: "Subscription Management",
      parentState: subscriptionManagementGroup,
      openParent: setSubscriptionManagementGroup,
    },
    {
      type: "child",        
      visible: user && user.isAdmin,
      iconName: "log-completed",
      label: "Manage Orders",
      parentState: subscriptionManagementGroup,
      route: AdminRoutes.MANAGESUBSCRIPTION_ORDER,
      openParent: setSubscriptionManagementGroup,
    },
    {
      type: "child",
      visible: user && user.isAdmin,
      iconName: "currency-convert",
      label: "Manage Subscriptions",
      parentState: subscriptionManagementGroup,
      route: AdminRoutes.MANAGESUBSCRIPTION,
      openParent: setSubscriptionManagementGroup 
    },
    {
      type: "menu",
      visible: user && (user.isSuperAdmin || user.isLibraryManager),
      iconName: "glossary",
      label: "Library Management",
      parentState: libraryManagementGroup,
      openParent: setLibraryManagementGroup,
    },
    {
      type: "child",
      visible: user && (user.isSuperAdmin || user.isLibraryManager),
      iconName: "folder-multiple",
      label: "Manage Library",
      parentState: libraryManagementGroup,
      route: AdminRoutes.MANAGELIBRARY,
      openParent: setLibraryManagementGroup,
    },
    {
      type: "child",
      visible: user && (user.isSuperAdmin || user.isLibraryManager),
      iconName: "category",
      label: "Manage Tags",
      parentState: libraryManagementGroup,
      route: AdminRoutes.MANAGELIBRARY_TAG,
      openParent: setLibraryManagementGroup,
    },
    {
      type: "child",
      visible: user && (user.isSuperAdmin || user.isLibraryManager),
      iconName: "dashboard",
      label: "Library Access History",
      parentState: libraryManagementGroup,
      route: AdminRoutes.MANAGELIBRARY_POSTACCESSHISTORY,
      openParent: setLibraryManagementGroup,
    },
    {
      type: "item",
      visible: user && (user.isSuperAdmin || (user.isToolsAndLibAdmin && user.hasReportingExport)),
      iconName: "email",
      label: "Email Notification Management",
      route: AdminRoutes.EMAILNOTIFICATION,
    },
  ];

  return (
    <MCSSideNavPanel ariaLabel="Admin Vertial Site Navigation"
      collapsed={true}
      tabList={adminMenuList}
      tabSelected={tabSelected}
      setTabSelected={setTabSelected}
    >
      {props.children}
    </MCSSideNavPanel>
  );
}

export default AdminNavPanel;
